export default defineAppConfig({
    useMockData: false,
});
